import React from 'react';
import { Redirect } from 'wouter';

import Route from '../common/components/Route';
import Clients from '../clients/table/Clients';
import Client from '../clients/detail/Client';
import Statistics from '../statistics/Statistics';
import Startpage from '../common/components/Startpage';
import Documentation from '../documentation/Documentation';
import Settings from '../settings/Settings';

function FhbfRoutes() {
  return (
    <>
      <Route path='/startpage' renderComponent={() => <Startpage />} />
      <Route path='/authentication' renderComponent={() => <Redirect to='/startpage' />} />
      <Route path='/' renderComponent={() => <Redirect to='/startpage' />} />
      <Route path='/fachberatungsstelle/clients' renderComponent={() => <Clients />} />
      <Route
        path='/fachberatungsstelle/clients/:clientId'
        renderComponent={(params) => <Client clientId={params.clientId} />}
      />
      <Route path='/fachberatungsstelle/documentation' renderComponent={() => <Documentation />} />
      <Route path='/fachberatungsstelle/statistics' renderComponent={() => <Statistics />} />
      <Route path='/fachberatungsstelle/settings' renderComponent={() => <Settings />} />
      <Route path='/interventionsstelle/clients' renderComponent={() => <Clients />} />
      <Route
        path='/interventionsstelle/clients/:clientId'
        renderComponent={(params) => <Client clientId={params.clientId} />}
      />
      <Route path='/interventionsstelle/documentation' renderComponent={() => <Documentation />} />
      <Route path='/interventionsstelle/statistics' renderComponent={() => <Statistics />} />
      <Route path='/interventionsstelle/governmentStatistics' renderComponent={() => <Statistics />} />
    </>
  );
}

export default FhbfRoutes;
